<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div :class="['IM_1_' + this.id]" style="height: 80vh;">
    <div class="d-flex justify-content-around" style="height: 92vh; width: 95%;">
      <div class="h-100" style="width: 600px;">
        <Design @send="sendDraw" />
      </div>
      <div class="h-100" style="width: 540px;">
        <drawerComponent ref="drawerComponent" style="margin-top: 30%;" />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import drawerComponent from "../draws/Drawer.vue";
import Design from "../draws/IM_1_7_design.vue";

export default {
  name: "IM_1_7",
  data: function () {
    return {
      id: 7,
      images: {}
    };
  },
  methods: {
    emitMusic: function (action, id) {
      this.$emit("audio", { action: action, id: id });
    },
    sendDraw: function () {
      this.$refs.drawerComponent.sendToAPI();
      this.emitMusic("play", 4);
    }
  },
  components: { drawerComponent: drawerComponent, Design }
};
</script>
<style lang="scss"></style>
